const TipoEtapaEnum = {
  5: 'Atualização',
  4: 'Internação',
  3: 'Notificação',
  2: 'Exame',
  1: 'Medicamento',
};

export default TipoEtapaEnum;
